import * as types from "../action/ActionType";
import type { AppAction } from "../action/ActionType";

export default function NotificationCountReducer(state: number = 0, action: AppAction): number {
  switch (action.type) {
    case types.NOTIFY_COUNT:
      return action.payload;
    default:
      return state;
  }
}
